export default "/_next/static/images/uneditableItemsImage-55a69eee9f5eb16b3a8bad41c70ff30f.png";